import { Injectable } from "@angular/core";
import { ChartData } from "./GraficosInterface";

@Injectable({
    providedIn: "root"
})
export class ArregloTransformer {

    constructor() {
    }

    public parsearArreglo(obj: string) {
        const label = obj.replace(/[\[\]]/g, "");
        const lastIndex = label.lastIndexOf(",");
        return [label.substring(0, lastIndex), label.substring(lastIndex + 2)];
    }

    public reemplazarTodo(str: string, find: string, replace: string) {
        return str.replace(new RegExp(find, "g"), replace);
    }

    public ordenarArreglo(array: ChartData[]) {
        array.sort((a, b) => {
            if (a.name > b.name) {
                return 1;
            }
            if (a.name < b.name) {
                return -1;
            }
            return 0;
        });
        return array;
    }
}
